import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { getSelectedWebsiteDomain, isAddingTrackedWebsite } from "../store/tracked_websites/selectors";
import { addTrackedWebsite } from "../store/tracked_websites/operations";
import { getRegionalDatabases } from "../store/regional_databases/selectors";
import { fetchRegionalDatabases } from "../store/regional_databases/operations";
import { getMaxRegionsNo, getMaxCompetitorsNo, getMaxKeywordsNo } from "../store/sales/selectors";
import { getMonitorLocations, getOrderOfMonitorLocation } from "../store/monitor_locations/selectors";
import { fetchMonitorLocations } from "../store/monitor_locations/operations";
import { fetchTrackedKeywordsCount } from "../store/tracked_keywords/operations";
import { getTrackedKeywordsCount, isAddingTrackedKeywords } from "../store/tracked_keywords/selectors";
import AddTrackedWebsiteWizard from "../components/shared/TrackedWebsites/TrackedWebsitesWizard/AddTrackedWebsiteWizard";
import { checkDomainsBlackList, sendOnboardingEvent } from "../store/tracked_websites/operations";
import { isSendingLoadingTimeRequest } from "../store/loading_time/selectors";
import { sendLoadingTimeRequest } from "../store/loading_time/operations";
import { getAccessToken } from "../store/iam/selectors";

export class AddTrackedWebsiteWizardContainer extends Component {
  constructor(props) {
    super(props);

    this.handleWizardSubmit = this.handleWizardSubmit.bind(this);
  }

  componentDidMount() {
    this.props.fetchMonitorLocations();
    this.props.fetchRegionalDatabases();
    this.props.fetchTrackedKeywordsCount();
  }

  handleWizardSubmit(mainUrl, seoDb, competitors, regions, keywords) {
    this.props.addTrackedWebsite(mainUrl, seoDb, competitors, regions, keywords, this.props.showStartScreen);
  }

  render() {
    return (
      <AddTrackedWebsiteWizard
        regionalDatabases={this.props.regionalDatabases}
        maxRegionsNo={this.props.maxRegionsNo}
        maxCompetitorsNo={this.props.maxCompetitorsNo}
        maxKeywordsNo={this.props.maxKeywordsNo}
        keywordsCount={this.props.keywordsCount}
        locations={this.props.locations}
        locationsOrder={this.props.locationsOrder}
        handleWizardSubmit={this.handleWizardSubmit}
        isAddingTrackedKeywords={this.props.isAddingTrackedKeywords}
        isAddingTrackedWebsite={this.props.isAddingTrackedWebsite}
        showStartScreen={this.props.showStartScreen}
        showSkip={this.props.showSkip}
        push={this.props.push}
        checkDomainsBlackList={this.props.checkDomainsBlackList}
        sendOnboardingEvent={this.props.sendOnboardingEvent}
        sendLoadingTimeRequest={this.props.sendLoadingTimeRequest}
        isSendingLoadingTimeRequest={this.props.isSendingLoadingTimeRequest}
        accessToken={this.props.accessToken}
      />
    );
  }
}

const mapStateToProps = state => ({
  domain: getSelectedWebsiteDomain(state),
  regionalDatabases: getRegionalDatabases(state),
  maxRegionsNo: getMaxRegionsNo(state),
  maxCompetitorsNo: getMaxCompetitorsNo(state),
  maxKeywordsNo: getMaxKeywordsNo(state),
  keywordsCount: getTrackedKeywordsCount(state),
  locations: getMonitorLocations(state),
  locationsOrder: getOrderOfMonitorLocation(state),
  isAddingTrackedKeywords: isAddingTrackedKeywords(state),
  isAddingTrackedWebsite: isAddingTrackedWebsite(state),
  isSendingLoadingTimeRequest: isSendingLoadingTimeRequest(state),
  accessToken: getAccessToken(state)
});

export default connect(mapStateToProps, {
  fetchMonitorLocations,
  fetchRegionalDatabases,
  fetchTrackedKeywordsCount,
  addTrackedWebsite,
  checkDomainsBlackList,
  sendOnboardingEvent,
  sendLoadingTimeRequest,
  push
})(AddTrackedWebsiteWizardContainer);
